export const contentTableConfig = {
  title: '回复列表',
  propList: [
    { prop: 'uname', label: '客户昵称', minWidth: '80' },
    { prop: 'remark', label: '备注', minWidth: '80' },
    { prop: 'content', label: '回复内容', minWidth: '100', align: 'left'},
    { prop: 'date', label: '回复时间', minWidth: '80', sortable: 'custom' },
    { prop: 'corpName', label: '主体名称', minWidth: '80' },
    { prop: 'sid', label: '账号ID', minWidth: '80' },
    { prop: 'sname', label: '账号名称', minWidth: '80' },
    { prop: 'usedBy', label: '使用人', minWidth: '80' },
    { prop: 'deptName', label: '所属部门', minWidth: '80' },
    { prop: 'groupName', label: '所属组', minWidth: '80' },
    {
      prop: 'replyDual',
      label: '业务员回复时长/未回复至今时长',
      slotName: 'replyDual',
      minWidth: '65'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
